import "jquery-validation";

/**
 * Handles form submition via ajax, validation reaptcha, and alerts
 * @param string formSelector
 * @param string the name off the action-hook to use
 * @param object validationArgs för jQuery.validate
 */
export class HandleSubmitForm {
    constructor(formSelector, validationArgs = {}) {
        this.form = document.querySelector(formSelector);
        this.sendBtn = this.form.querySelector("[type=submit]");
        this.actionName = null;
        this.debug = this.form.classList.contains("debug");

        if (this.form) {
            this.form.addEventListener("submit", event => {
                event.preventDefault();
                // ta bort tidigare meddelanden

                const [...alerts] = document.querySelectorAll(".alert");
                alerts.map(alert => {
                    alert.classList.add("alert--inactive");
                });
            });

            $(this.form).validate({
                ...validationArgs,
                submitHandler: this.handleRecaptcha.bind(this)
            });

            // make form submitable
            this.sendBtn?.classList.remove("disabled");
        }
    }

    set setActionName(actionName) {
        this.actionName = actionName;
    }

    handleRecaptcha() {
        grecaptcha.ready(async () => {
            const token = await grecaptcha.execute(horizon.recaptchaPublicKey, {
                action: this.actionName
            });
            this.handleSubmit(token);
        });
    }

    handleSubmit(token) {
        this.sendBtn?.classList.add("disabled", "true");

        const body = new FormData(this.form);
        body.append("action", this.actionName);
        body.append("g-recaptcha-response", token);

        fetch(horizon.ajaxUrl, {
            method: "POST",
            credentials: "same-origin",
            body
        })
            .then(resp => {
                this.sendBtn.classList.remove("disabled");
                return resp.json();
            })
            .then(data => {
                if (this.debug) console.log(data);
                this.handleResponseAlert(data);

                if (!this.debug && data.success) {
                    // remove form from DOM if successful
                    this.form.remove();
                }
            })
            .catch(error => {
                console.error(error);
            });
    }

    handleResponseAlert(data) {
        const [...alerts] = document.querySelectorAll(".alert--inactive");

        if (Array.isArray(alerts)) {
            alerts.forEach(alert => {
                // finns det inaktiva notiser
                if (alert.classList.contains("alert--inactive")) {
                    // är meddelande skickat och har notisen modifieraren --success
                    if (
                        data.success &&
                        alert.classList.contains("alert--success")
                    ) {
                        alert.classList.remove("alert--inactive");
                        // är meddelandet inte skickat och har notisen modifieraren --danger
                    } else if (
                        !data.success &&
                        alert.classList.contains("alert--danger")
                    ) {
                        alert.classList.remove("alert--inactive");
                    }
                    return;
                }
                alert.classList.remove("alert--inactive");
            });
            if (!this.debug) this.form.reset();
        }
    }
}
